import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import TStore from '../../types/store';
import { actions } from '../../store/ducks/news';
// import Breadcrumbs from '../../components/breadcrumbs';
import Article from './components/article';
import { TNewsDetail } from '../../types/news';
// import NextArticle from './components/next-article';

type TProps = {
  newsDetail: TNewsDetail | null;
  match: {
    params: {
      id: string;
    };
  };
  getDetailRequest(id: number): void;
};
const NewsDetail: React.FC<TProps> = ({ match, newsDetail, getDetailRequest }) => {
  const id = Number(match.params.id);

  useEffect(() => {
    getDetailRequest(id);
  }, [getDetailRequest, id]);

  return (
    <div style={{ background: '#fff' }}>
      {/*   <Breadcrumbs crumbs={breadcrumbs} /> */}
      {newsDetail !== null ? <Article newsDetail={newsDetail} /> : null}
      {/* <NextArticle /> */}
    </div>
  );
};

const mapStateToProps = (store: TStore) => ({
  newsDetail: store.news.currentDetail,
});

const mapDispatchToProps = (dispatch: any) => ({
  getDetailRequest: (id: number) => dispatch(actions.getNewsDetail(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsDetail);
